import React from 'react';
import { Check, X } from 'lucide-react';
export function UpsellComparison() {
  const features = [{
    name: '6 Core Business Volumes',
    basic: true,
    pro: true
  }, {
    name: '6 Strategic Bonuses',
    basic: true,
    pro: true
  }, {
    name: 'Lifetime Updates',
    basic: true,
    pro: true
  }, {
    name: '100+ Viral Hook Templates',
    basic: false,
    pro: true
  }, {
    name: '90-Day Content Matrix',
    basic: false,
    pro: true
  }, {
    name: 'Canva Template Library',
    basic: false,
    pro: true
  }, {
    name: 'Priority Support',
    basic: false,
    pro: true
  }];
  return <section className="bg-black py-12 border-b border-nero-border/20" data-id="element-292">
      <div className="max-w-4xl mx-auto px-4" data-id="element-293">
        <h3 className="text-white text-xl md:text-2xl font-bold text-center mb-8 font-playfair" data-id="element-294">
          Compare Packages
        </h3>

        <div className="overflow-x-auto rounded-xl border border-nero-border" data-id="element-295">
          <table className="w-full text-left border-collapse" data-id="element-296">
            <thead data-id="element-297">
              <tr className="bg-soft-gold text-black" data-id="element-298">
                <th className="p-4 font-bold w-1/2" data-id="element-299">Features</th>
                <th className="p-4 font-bold text-center w-1/4 border-l border-black/10" data-id="element-300">
                  MegaPack
                </th>
                <th className="p-4 font-bold text-center w-1/4 border-l border-black/10" data-id="element-301">
                  Bundle
                </th>
              </tr>
            </thead>
            <tbody data-id="element-302">
              {features.map((feature, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-[#0A0A0A]' : 'bg-[#111111]'} data-id="element-303">
                  <td className="p-4 text-white text-sm md:text-base border-t border-nero-border/30" data-id="element-304">
                    {feature.name}
                  </td>
                  <td className="p-4 text-center border-t border-l border-nero-border/30" data-id="element-305">
                    {feature.basic ? <Check className="w-5 h-5 text-soft-gold mx-auto" data-id="element-306" /> : <X className="w-5 h-5 text-gray-600 mx-auto" data-id="element-307" />}
                  </td>
                  <td className="p-4 text-center border-t border-l border-nero-border/30" data-id="element-308">
                    {feature.pro ? <Check className="w-5 h-5 text-soft-gold mx-auto" data-id="element-309" /> : <X className="w-5 h-5 text-gray-600 mx-auto" data-id="element-310" />}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}